import React, { useState } from 'react';
import '../../styles/MemberTransferContent.css';
import TransferRequestForm from './TransferRequestForm';
import OfficialDocumentation from './OfficialDocumentation';
import MembershipDashboard from './MembershipDashboard';

function MemberTransferContent() {
  const [activeTab, setActiveTab] = useState('TRANSFER REQUEST');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'TRANSFER REQUEST':
        return <TransferRequestForm />;
      case 'OFFICIAL DOCUMENTATION':
        return <OfficialDocumentation />;
      case 'MEMBERSHIP DASHBOARD':
        return <MembershipDashboard />;
      default:
        return <TransferRequestForm />;
    }
  };

  return (
    <div className="member-transfer-content">
      <div className="sub-navigation">
        <button
          className={`sub-nav-button ${activeTab === 'TRANSFER REQUEST' ? 'active' : ''}`}
          onClick={() => handleTabClick('TRANSFER REQUEST')}
        >
          TRANSFER REQUEST
        </button>
        <button
          className={`sub-nav-button ${activeTab === 'OFFICIAL DOCUMENTATION' ? 'active' : ''}`}
          onClick={() => handleTabClick('OFFICIAL DOCUMENTATION')}
        >
          OFFICIAL DOCUMENTATION
        </button>
        <button
          className={`sub-nav-button ${activeTab === 'MEMBERSHIP DASHBOARD' ? 'active' : ''}`}
          onClick={() => handleTabClick('MEMBERSHIP DASHBOARD')}
        >
          MEMBERSHIP DASHBOARD
        </button>
      </div>
      <div className="content-pane">
        {renderContent()}
      </div>
    </div>
  );
}

export default MemberTransferContent;